<template>
    <div class="v-raumplanung-quick-settings">

    </div>
</template>

<script setup lang="ts">
import { RaumplanungMapModule } from "@/mapModules/raumplanung/RaumplanungMapModule";

const props = defineProps<{
    mapModule: RaumplanungMapModule
}>();


</script>
